const Contact = () => {
  const name = 'Hal Barnett';
  return <div>Contact {name}</div>;
};

export default Contact;
